/**
 * RC make / CTD make pill toggle.
 *
 * Visible in both POS and Quick Order. When the user flips makes, the parent
 * is responsible for resetting `constructionType` to the new make's default
 * (the toggle just announces the change via onChange).
 *
 * Props:
 *   value     "rc" | "ctd"
 *   onChange  (next) => void
 *   compact   render the smaller chip variant (used in tight headers)
 */
import { MAKE_PROFILES } from "@/lib/makePricing";

export default function MakeToggle({ value = "rc", onChange, compact = false, className = "" }) {
  const Pill = ({ id, label, blurb, color }) => {
    const active = value === id;
    return (
      <button
        type="button"
        onClick={() => onChange?.(id)}
        data-testid={`make-toggle-${id}`}
        className={
          `flex items-center gap-2 transition-all border ` +
          (active
            ? "border-transparent text-white shadow-sm"
            : "border-white/10 bg-[#0a1628] text-slate-400 hover:text-white hover:border-white/20") +
          (compact ? " px-3 py-1.5 text-xs rounded-full" : " px-4 py-2 text-sm rounded-lg")
        }
        style={active ? { backgroundColor: color } : {}}
      >
        <span className={compact ? "w-1.5 h-1.5 rounded-full" : "w-2 h-2 rounded-full"} style={{ backgroundColor: active ? "#fff" : color }} />
        <span className="font-medium">{label}</span>
        {!compact && <span className={active ? "text-white/80 text-xs" : "text-slate-500 text-xs"}>· {blurb}</span>}
      </button>
    );
  };

  return (
    <div className={`inline-flex items-center gap-2 flex-wrap ${className}`} data-testid="make-toggle">
      <Pill id="rc"             label={MAKE_PROFILES.rc.label}             blurb={MAKE_PROFILES.rc.blurb}             color={MAKE_PROFILES.rc.color} />
      <Pill id="ctd"            label={MAKE_PROFILES.ctd.label}            blurb={MAKE_PROFILES.ctd.blurb}            color={MAKE_PROFILES.ctd.color} />
      <Pill id="rc_fabric_ctd"  label={MAKE_PROFILES.rc_fabric_ctd.label}  blurb={MAKE_PROFILES.rc_fabric_ctd.blurb}  color={MAKE_PROFILES.rc_fabric_ctd.color} />
      <Pill id="ctd_fabric_rc"  label={MAKE_PROFILES.ctd_fabric_rc.label}  blurb={MAKE_PROFILES.ctd_fabric_rc.blurb}  color={MAKE_PROFILES.ctd_fabric_rc.color} />
    </div>
  );
}
